




import Vue from 'vue';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { mapActionsDvm } from '@/main/pages';

import { store } from '../../store/edit';


export default Vue.extend({
	name: 'ZakazkaProvozovnaSelect',
	props: {
		storeUri: { type: String, default: null, required: true },
		isDisabled: { type: Boolean, default: false },
	},
	computed: {
		...genVuexComputeds(store),
	},
	watch: {
		ProvozovnaId() {
			this.VozidloRzv = null;
			this.VozidloVin = null;
			this.ZakaznikIdText = null;
			this.ZakaznikId = null;
			this.provozovnaChange();
		},
	},
	methods: {
		...mapActionsDvm(store.actions),
	},
});
